import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Shell from "./components/layout/Shell";
import HomePage from "./pages/HomePage";
import SalesOnboardingPage from "./pages/SalesOnboardingPage";
import ProductEducationPage from "./pages/ProductEducationPage";
import DesignIntentPage from "./pages/DesignIntentPage"; // Import the new page

function App() {
  return (
    <Router>
      <Shell>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/sales-onboarding" element={<SalesOnboardingPage />} />
          <Route path="/product-education" element={<ProductEducationPage />} />
          <Route path="/design-intent" element={<DesignIntentPage />} />{" "}
          {/* Add Route */}
        </Routes>
      </Shell>
    </Router>
  );
}

export default App;
